// Messaging between the widgets and the Unity app (Vuplex 3D WebView).
// Unity sends JSON strings: { "type": "battery.update", "value": ... }
// Widgets send objects: window.vuplex.postMessage({ type, value })

function whenVuplexReady(callback) {
    if (window.vuplex) {
        callback();
    } else {
        window.addEventListener('vuplexready', callback, { once: true });
    }
}

export function isInUnity() {
    return Boolean(window.vuplex);
}

export function postToUnity(type, value) {
    whenVuplexReady(() => window.vuplex.postMessage({ type, value }));
}

// Calls handler(value) for every message of the given type, returns an unsubscribe function
export function onUnityMessage(type, handler) {
    const listener = (event) => {
        let data;
        try {
            data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        } catch (e) {
            return;
        }
        if (data && data.type === type) {
            handler(data.value);
        }
    };

    let subscribed = true;
    whenVuplexReady(() => {
        if (subscribed) {
            window.vuplex.addEventListener('message', listener);
        }
    });

    return () => {
        subscribed = false;
        if (window.vuplex) {
            window.vuplex.removeEventListener('message', listener);
        }
    };
}
